// extracted by mini-css-extract-plugin
export default {"container":"InputCopy_container--wIs","tooltip":"InputCopy_tooltip--mH1","copyIcon":"InputCopy_copyIcon--KnI"};